import { Provider } from '@angular/core';
import { GOOGLE_MAPS_API_KEY } from '../tokens/google-maps-api.token';

export function provideGoogleMapsApi(apiKey: string): Provider[] {
  return [{ provide: GOOGLE_MAPS_API_KEY, useValue: apiKey }];
}
